/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Min_WeightInputs */

const en_min_weight = /** @type {(inputs: Min_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min weight`)
};

const es_min_weight = /** @type {(inputs: Min_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso min`)
};

/**
* | output |
* | --- |
* | "Min weight" |
*
* @param {Min_WeightInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const min_weight = /** @type {((inputs?: Min_WeightInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Min_WeightInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_min_weight(inputs)
	return es_min_weight(inputs)
});